import { render } from "./clean_table.vue?vue&type=template&id=a5d8d0d6&scoped=true"
import script from "./clean_table.vue?vue&type=script&lang=js"
export * from "./clean_table.vue?vue&type=script&lang=js"

import "./clean_table.vue?vue&type=style&index=0&id=a5d8d0d6&lang=scss&scoped=scoped"
import "./clean_table.vue?vue&type=style&index=1&id=a5d8d0d6&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d8d0d6"]])

export default __exports__